import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    standalone: false
})
export class PasswordResetComponent implements OnInit {

  constructor(
    // private _firestore = inject(Firestore),
    // public auth = getAuth(), // you have to inject(Firestore) first before writing this line
  ) { }

  ngOnInit(): void {
  }
  async sendPasswordResetEmail(passwordResetEmail: string) {
    // return await this.auth.sendPasswordResetEmail(passwordResetEmail);
  }

}
